module.exports = __webpack_public_path__ + "static/media/greet.79058e19.gif";